import i18n from "../../../../i18n";
import styles from "./AssessmentTypeStep.module.css";
import { ConfigHeader, CreateAssessmentTile } from "./shared";
import { baseTransKey } from "./verityAssessmentHelper";
import QuizIcon from "../../../../images/portal/verity-quiz.svg?react";
import AssignmentIcon from "../../../../images/portal/verity-assignment.svg?react";
import { CoreCard, CoreSkeletonWrapper } from "@verity/components/core";
import { VerityAssessmentType } from "@verity/database/prisma";

type AssessmentTypeStepProps = {
	selectedAssessmentType: VerityAssessmentType;
	onSelect: (type: VerityAssessmentType) => void;
	loading?: boolean;
};

export default function AssessmentTypeStep({ selectedAssessmentType, onSelect, loading }: AssessmentTypeStepProps) {
	return (
		<CoreCard
			className={styles.assessmentTypeCard}
			slotProps={{ bodyWrapper: { className: styles.assessmentTypeStep } }}
		>
			<CoreSkeletonWrapper loading={loading} width="50%" height={"50px"}>
				<ConfigHeader>{i18n.t(`${baseTransKey}.assessmentType.title`)}</ConfigHeader>
			</CoreSkeletonWrapper>
			<div className={styles.assessmentTypeTiles}>
				<CoreSkeletonWrapper loading={loading} width="100%" height={"200px"}>
					<CreateAssessmentTile
						icon={<QuizIcon />}
						description={i18n.t(`${baseTransKey}.assessmentType.quizDesc`)}
						onClick={() => onSelect("quiz")}
						selected={selectedAssessmentType === "quiz"}
						title={i18n.t(`${baseTransKey}.assessmentType.quizTitle`)}
					/>
				</CoreSkeletonWrapper>
				<CoreSkeletonWrapper loading={loading} width="100%" height={"200px"}>
					<CreateAssessmentTile
						icon={<AssignmentIcon />}
						description={i18n.t(`${baseTransKey}.assessmentType.assignmentDesc`)}
						onClick={() => onSelect("assignment")}
						selected={selectedAssessmentType === "assignment"}
						title={i18n.t(`${baseTransKey}.assessmentType.assignmentTitle`)}
					/>
				</CoreSkeletonWrapper>
			</div>
		</CoreCard>
	);
}
